export const token = `${process.env.REACT_APP_TOKEN}`;
export const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}`;
export const SSO_BUTTON_LABEL = process.env.REACT_APP_SSO_BUTTON_LABEL;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const SSO_AVAILABLE = process.env.REACT_APP_SSO_AVAILABLE === 'true';
export const SSO_APP_URL = process.env.REACT_APP_SSO_APP_URL;
export const ITEMS_PER_PAGE = 25;
export const errorMessage = "Something went wrong";
export const successMessage = "Action completed successfully";

export const SELECTED_JOURNAL_IDS_KEY = 'selectedJournalsIds';

export const notificationsTime = 3000;

export const defaultColor = "#4285F4";

export const watchlistSignals = [
  { label: 'Fake affiliation names', value: 'watchlist.fakeAffiliationNames' },
  { label: 'Fake names or e-mail addresses', value: 'watchlist.fakeNamesOrEmailAddresses' },
  { label: 'Fake e-mail domains', value: 'watchlist.fakeEmailDomains' },
  { label: 'Disposable e-mail domains', value: 'watchlist.disposableEmailDomains' },
  { label: 'Suspect articles', value: 'watchlist.suspectArticles' },
  { label: 'Manuscripts offered for sale', value: 'watchlist.manuscriptsOfferedForSale' },
  { label: 'Metadata suspects', value: 'watchlist.metadataSuspects' }
];

export const referenceSignals = [
  { label: 'DOI analysis', value: 'doiAnalysis' },
  { label: 'Retraction Watch', value: 'retractionWatch' },
];

export const textSignals = [
  { label: 'Tortured phrases', value: 'torturedPhrases' },
  { label: 'Suspect phrases', value: 'suspectPhrases' },
  { label: 'GenAI response', value: 'genAIResponse' },
  { label: 'Unnatural text', value: 'unnaturalText' },
];

export const regExpPassword =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-#!$'�??%^@&*()_+|~=`{}\[\]'<>?,.\/]).{8,}$/;
